import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatNumberEsPipe } from './format-number-es.pipe';
import { InvoiceStatusColorPipe } from '../pipes/invoice-status-color.pipe';
import { InvoiceStatusBadgePipe } from '../pipes/invoice-status-badge.pipe';
import { DateTimeSpanishPipe } from '../pipes/date-time-spanish.pipe';

@NgModule({
  declarations: [
    FormatNumberEsPipe,
    InvoiceStatusColorPipe,
    InvoiceStatusBadgePipe,
    DateTimeSpanishPipe
  ],
  imports: [CommonModule],
  exports: [
    FormatNumberEsPipe,
    InvoiceStatusColorPipe,
    InvoiceStatusBadgePipe,
    DateTimeSpanishPipe
  ]
})
export class SharedPipesModule { }
